import script from "./KendouAnalyzerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./KendouAnalyzerPage.vue?vue&type=script&setup=true&lang=js"

import "./KendouAnalyzerPage.vue?vue&type=style&index=0&id=b2df1cc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2df1cc0"]])

export default __exports__